import { render } from "./DialogNuovaManutenzione.vue?vue&type=template&id=5f140755&scoped=true"
import script from "./DialogNuovaManutenzione.vue?vue&type=script&lang=js"
export * from "./DialogNuovaManutenzione.vue?vue&type=script&lang=js"

import "./DialogNuovaManutenzione.vue?vue&type=style&index=0&id=5f140755&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f140755"]])

export default __exports__